import { useMutation, useQueryClient } from "@tanstack/react-query";

import { $api, fetchClient, invalidate } from "./client";
import type { components } from "./schema";

export type Integration = components["schemas"]["Integration"];

/**
 * GET /api/v1/integrations/ — the tenant's integrations. Admin-only,
 * unpaginated. `params` is the implementation's config blob; its keys are
 * opaque and are exempt from the camelCase wire format.
 */
export const useIntegrations = () =>
  $api.useQuery("get", "/api/v1/integrations/");

export function useUpdateIntegration() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      id,
      ...body
    }: { id: number } & components["schemas"]["PatchedIntegrationRequest"]) =>
      (
        await fetchClient.PATCH("/api/v1/integrations/{id}/", {
          params: { path: { id } },
          body,
        })
      ).data!,
    onSuccess: () => invalidate(queryClient, "/api/v1/integrations/"),
  });
}
